module.exports = __webpack_public_path__ + "static/media/kernelcon_w_trans.a939e036.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/kernelcon_w_trans.png
// module id = 44
// module chunks = 0